import ApiClient from './ApiClient'
import { withQuery } from '../../utils/urlParams'

const issueStatusesBase = collectId => `/collects/${collectId}/issue_statuses`
const SEARCH_KEY = 'q'
// Per-row validation errors key from the NestedFormValidator response contract.
const FORMATTED_ERRORS_KEY = 'formatted_errors'

class IssueStatusesService {
  static fetchAll(collectId, params = {}) {
    return ApiClient.get(withQuery(`${issueStatusesBase(collectId)}.json`, [
      [SEARCH_KEY, params.search],
      ['sort', params.sort],
      ['direction', params.direction]
    ]))
  }

  static batch(collectId, payload) {
    return ApiClient.patch(`${issueStatusesBase(collectId)}/batch.json`, payload).then(data => ({
      success: data.success !== false,
      formattedErrors: data[FORMATTED_ERRORS_KEY] || {}
    }))
  }
}

export default IssueStatusesService
